var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapSp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "92b5qd7w1a",
    d: "M13.333 16.889L8 15.013V4.444l5.333 1.876v10.569zm4.89-14.222l-.143.026-4.747 1.84L8 2.667 3.876 4.055c-.722.245-1.21.923-1.21 1.685v12.482c0 .25.196.445.445.445l.142-.027L8 16.8l5.333 1.867 4.124-1.39c.723-.243 1.21-.921 1.21-1.684V3.11c0-.249-.196-.444-.445-.444z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-309 -1031) translate(105 119) translate(160 904) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-309 -1031) translate(105 119) translate(160 904) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.333 5.333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kk10xypamb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#92b5qd7w1a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#323232",
    xlinkHref: "#92b5qd7w1a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#kk10xypamb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.333V21.333H0z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSp);
export default __webpack_public_path__ + "static/media/mapSP.26005f6f110bb7b21cfbc5ddfa26d67c.svg";
export { ForwardRef as ReactComponent };